import { projectRequest } from 'store/utils/request';

// eslint-disable-next-line import/prefer-default-export
export const getRuleEntitiesRequest = async params => {
  try {
    return await projectRequest.get(`/entities/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};
